import SQ_CAT from './i18nSq/cat.json';
// localized factory catalogue names (DE is the source in catalog.js)
export const CAT_NAMES = {
 "fr": {
  "w01": "Vanne de conduite (vanne d’isolement principale)",
  "w02": "Vanne de liaison (vanne de raccordement entre zones de pression)",
  "w03": "Vanne de branchement (vanne de raccordement particulier)",
  "w04": "Vanne papillon",
  "w05": "Collier de prise en charge avec vanne",
  "w06": "Collier de prise en charge sans vanne",
  "w07": "Bouche à clé fixe",
  "w08": "Bouche à clé réglable en hauteur",
  "w09": "Ensemble de bouche à clé / tube de protection télescopique",
  "w10": "Borne incendie enterrée",
  "w11": "Poteau incendie",
  "w12": "Borne incendie en regard",
  "w13": "Ventouse (soupape d’air/de vide)",
  "w14": "Vanne de vidange / point de purge",
  "w15": "Branchement particulier (conduite de branchement)",
  "w16": "Dispositif de coupure principal (vanne générale abonné)",
  "w17": "Compteur d’eau domestique",
  "w18": "Compteur de gros calibre / compteur combiné",
  "w19": "Compteur d’eau de chantier",
  "w20": "By-pass de compteur / installation de comptage",
  "w21": "Clapet anti-retour",
  "w22": "Réducteur de pression",
  "w23": "Compteur de secteur / regard de comptage DMA",
  "w24": "Réducteur de pression (PRV)",
  "w25": "Débitmètre (électromagnétique, MID)",
  "w26": "Enregistreur de données / enregistreur acoustique",
  "w27": "Point de mesure / point de contact",
  "w28": "Conduite d’eau potable en fonte ductile (DI)",
  "w29": "Conduite d’eau potable en HDPE / PE 100 RC",
  "w30": "Conduite d’eau potable en PVC",
  "w31": "Conduite d’eau potable en acier",
  "w32": "Conduite d’eau potable en amiante-ciment (AC)",
  "w33": "Collier de réparation / collier d’étanchéité",
  "w34": "Manchon / adaptateur à bride",
  "w35": "Manchon coulissant (manchon de réparation)",
  "w36": "Coude",
  "w37": "Té",
  "w38": "Réducteur",
  "w39": "Regard (regard de vanne / regard de compteur)"
 },
 "it": {
  "w01": "Saracinesca di linea (saracinesca di condotta principale)",
  "w02": "Saracinesca di collegamento",
  "w03": "Saracinesca di utenza (saracinesca di allacciamento)",
  "w04": "Valvola a farfalla",
  "w05": "Collare di presa con saracinesca",
  "w06": "Collare di presa senza saracinesca",
  "w07": "Chiusino stradale fisso",
  "w08": "Chiusino stradale regolabile in altezza",
  "w09": "Kit di installazione / tubo di protezione telescopico",
  "w10": "Idrante sottosuolo",
  "w11": "Idrante soprassuolo",
  "w12": "Idrante in pozzetto",
  "w13": "Sfiato/valvola di aerazione e disaerazione (ventosa)",
  "w14": "Saracinesca di scarico / bocchettone di lavaggio",
  "w15": "Condotta di allacciamento d'utenza",
  "w16": "Dispositivo generale di intercettazione (DGI)",
  "w17": "Contatore d'acqua domestico",
  "w18": "Contatore per grandi utenze / contatore combinato",
  "w19": "Contatore d'acqua di cantiere",
  "w20": "Staffa porta-contatore / gruppo di misura",
  "w21": "Valvola di non ritorno (VNR)",
  "w22": "Riduttore di pressione",
  "w23": "Contatore di zona / pozzetto di misura DMA",
  "w24": "Valvola di regolazione della pressione (PRV)",
  "w25": "Misuratore di portata (MID)",
  "w26": "Data logger / logger acustico",
  "w27": "Punto di misura / punto di contatto",
  "w28": "Condotta acqua potabile in ghisa sferoidale (GGG)",
  "w29": "Condotta acqua potabile in PE-HD / PE 100 RC",
  "w30": "Condotta acqua potabile in PVC",
  "w31": "Condotta acqua potabile in acciaio",
  "w32": "Condotta acqua potabile in fibrocemento",
  "w33": "Fascia di riparazione / fascia di tenuta",
  "w34": "Giunto / adattatore a flangia",
  "w35": "Manicotto scorrevole",
  "w36": "Curva",
  "w37": "Raccordo a T",
  "w38": "Riduzione",
  "w39": "Pozzetto (pozzetto per apparecchiature / di misura)"
 },
 "en": {
  "w01": "Line valve (main isolation valve)",
  "w02": "Coupling valve (connecting valve between pressure zones)",
  "w03": "Service valve (house connection valve)",
  "w04": "Butterfly valve",
  "w05": "Tapping valve with gate valve",
  "w06": "Tapping saddle without valve",
  "w07": "Surface box, fixed",
  "w08": "Surface box, height-adjustable",
  "w09": "Valve box set / telescopic protection tube",
  "w10": "Underground hydrant",
  "w11": "Pillar hydrant",
  "w12": "Chamber hydrant",
  "w13": "Air valve (air release/vacuum valve)",
  "w14": "Drain valve / flushing outlet",
  "w15": "House service pipe (service line)",
  "w16": "Main shut-off device (consumer main stop valve)",
  "w17": "Domestic water meter",
  "w18": "Bulk water meter / compound meter",
  "w19": "Construction water meter",
  "w20": "Meter bypass assembly / meter installation",
  "w21": "Check valve (non-return valve)",
  "w22": "Pressure reducing valve",
  "w23": "District meter / DMA meter chamber",
  "w24": "Pressure reducing valve (PRV)",
  "w25": "Flow meter (electromagnetic, MID)",
  "w26": "Data logger / acoustic logger",
  "w27": "Measuring point / contact point",
  "w28": "Drinking water pipe, ductile iron (DI)",
  "w29": "Drinking water pipe, HDPE / PE 100 RC",
  "w30": "Drinking water pipe, PVC",
  "w31": "Drinking water pipe, steel",
  "w32": "Drinking water pipe, asbestos cement (AC)",
  "w33": "Repair clamp / sealing clamp",
  "w34": "Coupling / flange adapter",
  "w35": "Sliding sleeve (repair sleeve)",
  "w36": "Bend",
  "w37": "Tee",
  "w38": "Reducer",
  "w39": "Chamber (valve chamber / meter chamber)"
 },
 "es": {
  "w01": "Válvula de seccionamiento (válvula de la red principal)",
  "w02": "Válvula de acoplamiento",
  "w03": "Válvula de acometida (válvula de la acometida domiciliaria)",
  "w04": "Válvula de mariposa",
  "w05": "Collarín de toma en carga con válvula",
  "w06": "Collarín de toma sin válvula",
  "w07": "Tapa de registro de calzada fija",
  "w08": "Tapa de registro de calzada regulable en altura",
  "w09": "Juego de instalación / tubo telescópico de protección",
  "w10": "Hidrante subterráneo (hidrante enterrado)",
  "w11": "Hidrante de columna (hidrante aéreo)",
  "w12": "Hidrante en arqueta",
  "w13": "Ventosa (válvula de aireación y purga)",
  "w14": "Válvula de vaciado / boca de limpieza",
  "w15": "Conducción de acometida (tubería de acometida)",
  "w16": "Llave de corte general (LCG)",
  "w17": "Contador de agua doméstico",
  "w18": "Contador de gran caudal / contador combinado",
  "w19": "Contador de agua de obra",
  "w20": "Puente de contador / batería de contadores",
  "w21": "Válvula de retención (VR)",
  "w22": "Reductor de presión",
  "w23": "Contador de sector / arqueta de medición DMA",
  "w24": "Válvula reguladora de presión (VRP)",
  "w25": "Caudalímetro electromagnético (MID)",
  "w26": "Registrador de datos / registrador acústico (correlador de ruido)",
  "w27": "Punto de medición / punto de contacto",
  "w28": "Tubería de agua potable de fundición dúctil (GGG)",
  "w29": "Tubería de agua potable de PE-AD / PE 100 RC",
  "w30": "Tubería de agua potable de PVC",
  "w31": "Tubería de agua potable de acero",
  "w32": "Tubería de agua potable de fibrocemento",
  "w33": "Abrazadera de reparación / abrazadera de estanqueidad",
  "w34": "Manguito de unión / adaptador de brida",
  "w35": "Manguito deslizante",
  "w36": "Codo",
  "w37": "Té",
  "w38": "Reducción",
  "w39": "Arqueta (arqueta de valvulería / de medición)"
 },
 "pt": {
  "w01": "Válvula de seccionamento (válvula da conduta principal)",
  "w02": "Válvula de acoplamento",
  "w03": "Válvula de ramal (válvula de ramal domiciliário)",
  "w04": "Válvula de borboleta",
  "w05": "Acessório de tomada em carga com válvula",
  "w06": "Colar de tomada em carga sem válvula",
  "w07": "Tampa de rua fixa (tampão de válvula)",
  "w08": "Tampa de rua com ajuste de altura",
  "w09": "Conjunto de manobra / tubo de proteção telescópico",
  "w10": "Boca de incêndio subterrânea (BI subterrânea)",
  "w11": "Marco de incêndio (MI)",
  "w12": "Boca de incêndio em câmara",
  "w13": "Ventosa (válvula de entrada e saída de ar)",
  "w14": "Válvula de descarga / bocal de purga",
  "w15": "Ramal domiciliário (ramal de ligação)",
  "w16": "Válvula de corte geral (válvula de corte do ramal)",
  "w17": "Contador de água doméstico",
  "w18": "Contador de grande calibre / contador combinado",
  "w19": "Contador de água para obras",
  "w20": "Montagem do contador / instalação de contagem",
  "w21": "Válvula de retenção (VR)",
  "w22": "Redutor de pressão",
  "w23": "Contador de zona / câmara de medição de ZMC",
  "w24": "Válvula redutora de pressão (VRP)",
  "w25": "Medidor de caudal (eletromagnético)",
  "w26": "Registador de dados / registador acústico (pré-localizador de fugas)",
  "w27": "Ponto de medição / ponto de contacto",
  "w28": "Conduta de água potável em ferro fundido dúctil (FFD)",
  "w29": "Conduta de água potável em PEAD / PE 100 RC",
  "w30": "Conduta de água potável em PVC",
  "w31": "Conduta de água potável em aço",
  "w32": "Conduta de água potável em fibrocimento",
  "w33": "Abraçadeira de reparação / abraçadeira de vedação",
  "w34": "Acoplamento / adaptador de flange",
  "w35": "União de deslizamento (manga de correr)",
  "w36": "Curva",
  "w37": "Tê",
  "w38": "Cone de redução",
  "w39": "Câmara (câmara de válvulas / de medição)"
 }
};

CAT_NAMES.sq = SQ_CAT;
